export const REQUEST_STATUS = {
   SIGNED: "Signed",
   COMPLETED: "Completed",
   IN_PROGRESS: "In Progress",
   INPROGRESS: "InProgress",
   DECLINED: "Declined",
   READY: "Ready"
}

export const recipientStatus = (envelopes, id) => {
   const status = [REQUEST_STATUS.SIGNED, REQUEST_STATUS.COMPLETED, REQUEST_STATUS.DECLINED, REQUEST_STATUS.IN_PROGRESS].includes(envelopes?.filter(item => item.id == id)[0]?.status);
   return status
}

export const regx = {
   emailFormat: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
   characters: /^[a-zA-Z]+$/
}

export const isEmpty = (val) => (Array.isArray(val) && !val.length || typeof val === 'object' && !Object.keys(val || {}).length || !val);

export const isNull = (val) => typeof val == 'undefined' || val == null;

export const getLength = (val) => (Array.isArray(val) && val?.length || typeof val === 'object' && Object.keys(val || {})?.length || val?.length);

export const clientTenant = ['engen','lumeris','triples'];

export function getCurrentUser(envelope, activeUserEmailId, annot, date = '') {
   if (!envelope) return;
   const fieldName = annot.fieldName || '';
   const [prefix, prefixDate] = fieldName.toLowerCase().split('_');
   const routingOrder = envelope?.find(item => item.email == activeUserEmailId)?.routingOrder;
   const lowerPrefix = prefix || '';

   const isSignerOrder = /^sign(er)?/.test(lowerPrefix);

   const currentUserRoutingOrder = isSignerOrder ? routingOrder == lowerPrefix.replace(/\D/g, '') : lowerPrefix == activeUserEmailId;

   if (currentUserRoutingOrder && date == 'date') {
      if (prefixDate.startsWith('date') || prefixDate.startsWith('date.')) {
         return prefixDate == (prefixDate.replace(/\d/g, '') + routingOrder)
      }
      return
   };

   console.log("~ getCurrentUser:", lowerPrefix, "-", prefixDate, "-", currentUserRoutingOrder)

   return currentUserRoutingOrder
}

export function getDateFormat(date) {
   const pad = (num) => String(num).padStart(2, '0');

   const year = date.getFullYear();
   const month = pad(date.getMonth() + 1);
   const day = pad(date.getDate());
   const hours24 = date.getHours();
   const hours = pad(hours24);
   const minutes = pad(date.getMinutes());
   const amOrPm = hours24 < 12 ? 'AM' : 'PM';
   const today = `${month}/${day}/${year}`;

   return today;
}

export function isValid(id = '', type = '') {
   if (!id || !type) return;

   if (Array.isArray(type)) {
      return type.includes(id);
   }
   else {
      return type === id;
   }
}